module.exports = __webpack_public_path__ + "img/DNADamage-LICA_GSE236681.7ace87de.png";